module.exports = __webpack_public_path__ + "img/cyxy.82c9701b.jpg";